export default "__VITE_ASSET__CFEju0vl__"